export default __webpack_public_path__ + "static/elemente-2@2x-e3a08a3693f019aeb6db5b23fdab7c2b.png";